import { buildQueryHelpers, OperationIds } from '../../util'
import {
  createBlockConnector,
  deleteBlockConnector,
  createCustomFieldValue,
  deleteCustomFieldValue,
  updateBlockBoards,
  updateBlockDetails,
  updateCustomFieldValue,
} from './cacheTransformFns'
import { readBlock as readSingleBlock, readBlocks } from './requests'
import { createResourceObject } from './resourceObject'
import { BlockKey } from './types'
import { useReadBlock } from './useReadBlock'

export const blocks = {
  readSingle: readSingleBlock,
  readCollection: readBlocks,
  resourceObject: createResourceObject,
}

export const readBlock = {
  ...buildQueryHelpers<OperationIds.ExperimentalReadBlockBFFV1, BlockKey>(
    'block',
    OperationIds.ExperimentalReadBlockBFFV1
  ),
  queryIdentifiers: (workspaceUuid: string, blockId: string): BlockKey => ({
    workspaceUuid,
    resourceId: blockId,
    queryParams: null,
  }),
  transformCache: {
    createCustomFieldValue,
    deleteCustomFieldValue,
    updateBlockBoards,
    updateBlockDetails,
    updateCustomFieldValue,
    createBlockConnector,
    deleteBlockConnector,
  },
  useQuery: useReadBlock,
}
